module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/9_8b70febde792fff0c7ddf4807a070291.jpg";